module.exports = __webpack_public_path__ + "static/the-substation-789f9889875d1e8dcb11721bfbcd9a3b.png";